import introBackground from "../assets/images/tetris/logo-proyecto.png";
import introButton from "../assets/images/tetris/button_1.png";
import useScreenOrientation from './helpers/useScreenOrientation';

export default function Intro({ isVisible, setView }: any) {

  const isLandscape = useScreenOrientation();

  return (
    <div className={`full-intro-container ${isVisible === true ? 'active' : 'hidden'}`}>
      <div className={`intro-title ${isLandscape ? '' : 'portrait'}`}>
        <img className={`intro-title-img ${isLandscape ? '' : 'portrait'}`} src={introBackground} alt=''/>
      </div>
      <img className={`intro-description-img ${isLandscape ? '' : 'portrait'}`} src={introButton} alt='' onClick={() => setView("UserForm")}/>
    </div>
  );
}